import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from '../../containers/Text';
import './HomePage.scss';
import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import { Mail, Phone } from 'lucide-react';

const PersonalSupportSection = () => {
  const { t } = useTranslation();

  return (
    <section className="personal-support-section">
      <div className="support-content">
        <div className="support-text">
          <h3 className="support-title">
            <Text text={t('personal-support-title')} />
          </h3>
          <p className="support-description">
            <Text text={t('personal-support-description')} />
          </p>
          <div className='support-subtitle'>
            <Text text={t('contact-info')} />
          </div>
          <p className="support-description">
            <div className="contact-info">

              <div>
                <Mail className='contact-icon' />
                <p className="contact-mail">
                  <a
                    href="mailto:info@yeuls.co.il"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Text text="info@yeuls.co.il" />
                  </a>
                </p>
              </div>
              <div>
                <Phone className='contact-icon' />
                <Text text={t('support-phone')} />
              </div>
            </div>
          </p>
        </div>
      </div>
    </section>
  );
};

export default PersonalSupportSection;
